module.exports = __webpack_public_path__ + "img/1_1-parco-2-bosco.5a302bde.png";